import { createContext, useContext } from "react";

// When true, ProductCatalogField hides its "From stock" inventory picker. Used
// by the hearing-aid wizard for quotes, which are estimates and must not reserve
// clinic inventory (SN-18215). Defaults to false so every other caller is
// unaffected.
const HideFromStockContext = createContext<boolean>(false);

export const HideFromStockProvider = HideFromStockContext.Provider;

export function useHideFromStock(): boolean {
  return useContext(HideFromStockContext);
}

export default HideFromStockContext;
